"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var FinanceReconciliationPartnersListCtl = /** @class */ (function (_super) {
    __extends(FinanceReconciliationPartnersListCtl, _super);
    function FinanceReconciliationPartnersListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_usr_partner_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_partner_id; });
        _this.dk_usr_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_partner_login; });
        _this.dk_amount_sub = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_sub; });
        _this.dk_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount; });
        _this.dk_amount_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_before; });
        _this.dk_partner_level = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_level; });
        _this.dk_top_partner_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.top_partner_id; });
        _this.dk_top_partner_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.top_partner_title; });
        _this.dk_partner_path = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_path; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_usr_partner_flow_id_player = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_partner_flow_id_player; });
        _this.dk_usr_partner_flow_id_sub = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_partner_flow_id_sub; });
        _this.dk_usr_partner_flow_id_reset = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_partner_flow_id_reset; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    FinanceReconciliationPartnersListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    FinanceReconciliationPartnersListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    FinanceReconciliationPartnersListCtl.prototype.LoadDataByReconciliationList = function (data, onDone) {
        var _this = this;
        webAApi_1.ListReconciliationPartnersByReconciliationIdGet.exec({
            usr_partner_reconciliation_id: data.usr_partner_reconciliation_id,
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    usr_partner_id: resp.list[i].usr_partner_id,
                    usr_partner_login: resp.list[i].usr_partner_login,
                    amount_sub: resp.list[i].amount_sub,
                    amount: resp.list[i].amount,
                    amount_before: resp.list[i].amount_before,
                    partner_level: resp.list[i].partner_level,
                    top_partner_id: resp.list[i].top_partner_id,
                    top_partner_title: resp.list[i].top_partner_title,
                    partner_path: resp.list[i].partner_path,
                    is_locked: resp.list[i].is_locked,
                    usr_partner_flow_id_player: resp.list[i].usr_partner_flow_id_player,
                    usr_partner_flow_id_sub: resp.list[i].usr_partner_flow_id_sub,
                    usr_partner_flow_id_reset: resp.list[i].usr_partner_flow_id_reset,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceReconciliationPartnersListCtl.prototype.LoadDataByReconciliationPartnerList = function (data, onDone) {
        var _this = this;
        webAApi_1.ListReconciliationSubPartnersByReconciliationPartnerIdGet.exec({
            usr_partner_reconciliation_partner_id: data.usr_partner_reconciliation_partner_id,
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    usr_partner_id: resp.list[i].usr_partner_id,
                    usr_partner_login: resp.list[i].usr_partner_login,
                    amount_sub: resp.list[i].amount_sub,
                    amount: resp.list[i].amount,
                    amount_before: resp.list[i].amount_before,
                    partner_level: resp.list[i].partner_level,
                    top_partner_id: resp.list[i].top_partner_id,
                    top_partner_title: resp.list[i].top_partner_title,
                    partner_path: resp.list[i].partner_path,
                    is_locked: resp.list[i].is_locked,
                    usr_partner_flow_id_player: resp.list[i].usr_partner_flow_id_player,
                    usr_partner_flow_id_sub: resp.list[i].usr_partner_flow_id_sub,
                    usr_partner_flow_id_reset: resp.list[i].usr_partner_flow_id_reset,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceReconciliationPartnersListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    FinanceReconciliationPartnersListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletReconciliationPartner.exec({
                data: {
                    usr_partner_reconciliation_partner_id: key
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    FinanceReconciliationPartnersListCtl.prototype.DoSetIsLocked = function (usrPartnerReconciliationId, isLocked, onDone) {
        var _this = this;
        webAApi_1.DoSetReconciliationPartnerIsLocked.exec({
            data: {
                usr_partner_reconciliation_partner_id: usrPartnerReconciliationId,
                is_locked: isLocked
            }
        }, function (resp) {
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceReconciliationPartnersListCtl.prototype.DoMakeFlowObjects = function (usrPartnerReconciliationId, onDone) {
        var _this = this;
        webAApi_1.DoMakeFlowObjectsByReconciliationPartnerId.exec({
            data: {
                usr_partner_reconciliation_partner_id: usrPartnerReconciliationId
            }
        }, function (resp) {
            _this.Update();
            if (onDone) {
                onDone(resp.created_count);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return FinanceReconciliationPartnersListCtl;
}(BaseController_1.BaseController));
exports.FinanceReconciliationPartnersListCtl = FinanceReconciliationPartnersListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_reconciliations/ctl/FinanceReconciliationPartnersListCtl.ts
// module id = 458
// module chunks = 0